import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'title-size': [
                'title-xxs',
                'title-xs',
                'title-s',
                'title-m',
                'title-l',
                'title-xl',
                'title-2xl',
            ],
            z: [{ z: ['modal'] }],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export default { cn };
